<template>
  <ld-json :json="jsonld" />
</template>

<script>
import { LdJson } from 'atoms';

import catalogMixin from '@/mixins/catalogMixin.vue';
import catalogTextListMixin from '@/mixins/catalogTextListMixin.vue';

export default {
  name: 'ProductFamilySchemaFi',
  components: {
    LdJson,
  },
  mixins: [catalogMixin, catalogTextListMixin],
  props: {
    variants: {
      type: Array,
      default: null,
    },
    categoryData: {
      type: Object,
      default: null,
    },
  },
  computed: {
    jsonld() {
      if (this.categoryData && this.textListValue(this.categoryData.TextList, 'BEZEICHNUNG')) {
        const base = `${this.$fischer.hostUrlBase()}${this.$fischer.pages.products().url}`;
        let variantsObj = [];

        if (this.variants?.length) {
          variantsObj = this.variants.map((variant) => {
            const { Name, Slug, ImageURL, ID } = variant.variantValuesObject[0];
            if (Name) {
              return {
                '@type': 'Product',
                name: Name,
                url: `${base}${Slug}`,
                productID: ID,
                image: ImageURL,
              };
            }
          });
        }

        return JSON.stringify({
          '@context': 'https://schema.org/',
          '@type': 'ProductGroup',
          '@id': `${base}${this.categoryData.Slug}`,
          brand: this.$fischer.brandName(),
          name: this.textListValue(this.categoryData.TextList, 'BEZEICHNUNG'),
          description: this.categoryData.description,
          image: this.getFamilyThumbnails(this.categoryData)?.map((el) => el.Url)?.[0],
          hasVariant: variantsObj,
        });
      }

      return null;
    },
  },
};
</script>
